export default __webpack_public_path__ + "static/11-removebg-preview-90760186670b66821cbce1989b442b6d.png";